/*
 * Initializing bootstrap tooltips
 */

$(function () {

    $(window).on('load', function(){
        if ( $('document').tooltip ){
            $('[data-toggle="tooltip"]').tooltip();
        }
    })
    
});
